module.exports = __webpack_public_path__ + "img/sarah.0dece01.webp";